<template>
  <van-overlay class="van-overlay" :show="show">
    <theme-image class="customer_wrap2" path="Index" name="online_customer_pop_bg">
      <div class="popup_close2" :class="{ popup_close_android: isAndroid() }" @click="close">
        <IconFont name="close-o" :size="60" color="#fff" />
      </div>
      <div class="customer_content">
        <div class="custom_phone_time">
          若您遇到问题，请以下方式联系客服
          <br />
          {{ DefaultMerchantInfo.customerTimeShow }}
        </div>
        <van-button @click="onlineClick" class="custom-button">在线咨询</van-button>
        <van-button plain @click="callNow" class="custom-button">立即呼叫</van-button>
        <div class="online_bottom_customer_phone">
          <span>客服电话：{{ DefaultMerchantInfo.phoneNumberShow }}</span>
        </div>
      </div>
    </theme-image>
  </van-overlay>
</template>

<script setup lang="ts">
import {
  tcJumpActivity,
  tcCallPhone,
  isAndroid,
  isAideApp,
  tcJumpAideAppActivity,
} from "@/utils/bridge/index.js";
import { DefaultMerchantInfo } from "@/constants/merchantInfo";

const props = defineProps({
  show: Boolean,
});
const emit = defineEmits(["close"]);

const close = () => emit("close");
const onlineClick = () => {
  // 甜瓜助手app专用
  if (isAideApp()) {
    tcJumpAideAppActivity("/customer");
  } else {
    // 其他逻辑不变
    tcJumpActivity("/customer");
  }
  emit("close");
};
const callNow = () => {
  tcCallPhone(DefaultMerchantInfo.phoneNumber);
  emit("close");
};
</script>

<style scoped lang="scss">
.van-overlay {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.customer_wrap2 {
  position: relative;
  display: block;
  width: 606px;
  height: 709px;
}

.popup_close2 {
  position: absolute;
  top: -20px;
  right: 0px;
  width: 60px;
  height: 60px;

  .popup_close_img2 {
    width: 100%;
  }
}

.popup_close_android {
  top: -50px;
}
.customer_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 258px;
}

.custom_phone_time {
  width: 452px;
  margin-bottom: 66px;
  font-size: 28px;
  line-height: 42px;
  color: #666f83;
  text-align: center;
}
.custom-button {
  margin-top: 10px;
  margin-bottom: 10px;
}

.online_bottom_customer_phone {
  bottom: 30px;
  left: 140px;
  font-size: 28px;
  color: #666f83;
  text-align: center;
}
</style>
